<template>
  <div class="event-page">
    <NavHeaderBar :showSearch="false" :navBarTitle="$t('shared.visitPlan')">
    </NavHeaderBar>

    <div class="list-container" v-if="!successStatus">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list v-model="loading" :finished="finished" :finished-text="$t('tips.noMoreData')" @load="onLoad">
          <div v-for="(item, index) in planList" :key="index" class="plan-card" @click="toPage(`/visitPlan/detail?planId=${item.id}`)">
            <div class="plan-left">
              <div class="plan-name van-ellipsis">{{ item.planName }}</div>
              <div class="plan-info van-ellipsis">{{ item.customerCount }} {{ $t('shared.stores') }}、{{ item.sdCount }} {{ $t('shared.distributor') }}</div>
              <!-- 计划拜访日期 -->
              <div class="plan-date van-ellipsis">{{ $t('shared.plannedVisitDate') }}：{{ item.planTime }}</div>
            </div>
            <div v-if="paramUrl.targetId" class="plan-right" style="justify-content: flex-end;">
              <img class="icon-img" src="@/assets/images/event_del.png" alt="" @click.stop="handleOper('del', item)">
            </div>
            <div v-else class="plan-right">
              <img class="icon-img" src="@/assets/images/incentive_edit.png" alt="" @click.stop="handleOper('edit', item)">
              <img class="icon-img" src="@/assets/images/del_icon.png" alt="" @click.stop="handleOper('del', item)">
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
    <div class="success-submit-status" v-else>
      <img class="success-img" src="@/assets/images/gouxuan.png" alt="">
      <!-- 拜访计划创建成功，添加stores/Dritributions到计划可规划拜访路线 -->
      <span class="success-tip">{{ $t('shared.titleThirtyOne') }}.</span>
      <div v-if="checkPer(['admin', 'app:expandCustomer']) || checkPer(['admin', 'app:customer'])" class="store-detail-btn" @click="toPage(`/shared/selectVisitPlan?pageType=store&planId=${currentSaveData.id}`)">{{ $t('button.addStores') }}</div>
      <div v-if="checkPer(['admin', 'app:sd'])" class="visit-sell-in-btn" @click="toPage(`/shared/selectVisitPlan?pageType=distributor&planId=${currentSaveData.id}`)">{{ $t('button.addDistributors') }}</div>
    </div>

    <!-- Bottom Button -->
    <div class="oper-btn" v-if="!successStatus">
      <!-- {{ paramUrl.targetId ? `添加${paramUrl.pageType === 'salesDistribution' ? 'distributor' : '门店'}到更多拜访计划` : '创建拜访计划' }} -->
      <van-button class="mapping-btn" type="info" @click="handleOper('add')">{{ paramUrl.targetId ? $t('shared.titleThirtyTwo', { keyVal: paramUrl.pageType === 'salesDistribution' ? $t('shared.distributor') : $t('shared.store') }) : $t('shared.createVisitPlan') }}</van-button>
    </div>
    <van-popup v-model="planPopup" position="bottom" :round="true" :style="{ 'max-height': '566px', 'min-height': '266px' }" get-container="#app">
      <div class="plan-popup-content">
        <div class="popup-title">{{ planForm.id ? $t('button.edit') : $t('button.create') }} {{ $t('shared.visitPlan') }}</div>
        <div class="plan-form-content">
          <div class="form-item">
            <div class="label required">
              <span>{{ $t('form.planName') }}</span>
            </div>
            <van-field v-model="planForm.planName" placeholder="" :border="false" maxlength="100" />
          </div>
          <div class="form-item">
            <div class="label required">
              <span>{{ $t('form.plannedVisitDate') }}</span>
            </div>
            <van-field :value="planForm.planTime" readonly :placeholder="$t('shared.filter.selectDate')" @click="showDatePicker = true" :border="false" />
            <van-popup v-model="showDatePicker" position="bottom">
              <van-datetime-picker
                v-model="currentDate"
                type="date"
                :title="$t('shared.filter.selectDate')"
                :min-date="minDate"
                @confirm="onDateConfirm"
                @cancel="showDatePicker = false"
              />
            </van-popup>
          </div>
          <div class="form-item">
            <div class="label">
              <span>{{ $t('form.addToSchedule') }}</span>
            </div>
            <van-field>
              <template #input>
                <van-switch v-model="planForm.isAddSchedule" size="20" inactive-color="#eaeaec" />
              </template>
            </van-field>
          </div>
          <div class="plan-tips">{{ $t('tips.messageFiftyTwo') }}</div>
        </div>
        <div class="operate-btn">
          <van-button type="primary" @click="planPopup = false">{{ $t('button.cancel') }}</van-button>
          <van-button class="confirm-btn" type="primary" @click="handleOper('confirm')">{{ $t('button.confirm') }}</van-button>
        </div>
      </div>
    </van-popup>
    <PlanType ref="planTypeRef" :currentPlanInfo="{ targetId: paramUrl.targetId, targetType: paramUrl.targetType }" @handlePlan="handlePlan" />
  </div>
</template>

<script>
import { visitPlanListPageApi, visitPlanAddApi, visitPlanDeleteApi, visitPlanDeleteDetailApi } from '@/api/visitPlan'
import moment from 'moment'
import { Toast, Dialog, Notify } from 'vant'
export default {
  name: 'VisitPlanIndex',
  components: {
    PlanType: () => import('./planType')
  },
  data () {
    return {
      // List State
      planList: [],
      loading: false,
      finished: false,
      refreshing: false,
      page: 1,
      limit: 10,
      planPopup: false,
      currentDate: new Date(),
      minDate: new Date(),
      planForm: {
        id: '',
        planName: '',
        planTime: '',
        isAddSchedule: false
      },
      showDatePicker: false,
      currendOper: '',
      successStatus: false,
      navTitle: this.$t('shared.visitPlan'),
      currentSaveData: {},
      paramUrl: {}
    }
  },
  watch: {
    planPopup (newVal) {
      if (!newVal) {
        this.planForm = {
          id: '',
          planName: '',
          planTime: '',
          isAddSchedule: false
        }
      }
    }
  },
  created () {},
  activated () {
    this.paramUrl = this.$route.query || {}
  },
  deactivated () {
    this.$destroy()
  },
  methods: {
    toPage (url) {
      this.$router.push(url)
    },
    // --- API & List Logic ---
    async onLoad () {
      if (this.refreshing) {
        this.planList = []
        this.refreshing = false
      }

      if (this.page === 1) {
        this.planList = []
      }

      try {
        const params = {
          page: this.page,
          limit: this.limit,
          targetId: this.paramUrl.targetId || '',
          targetType: this.paramUrl.targetType || ''
        }
        Toast.loading({
          message: this.$t('shared.loading'),
          forbidClick: true,
          duration: 0
        })
        const res = await visitPlanListPageApi(params)
        Toast.clear()
        if (this.refreshing) {
          this.planList = res.data.list
          this.refreshing = false
        } else {
          this.planList = [...this.planList, ...res.data.list]
        }

        this.page++
        if (this.planList.length === Number(res.data.totalRow)) {
          this.finished = true
        }
      } catch (error) {
        console.error(error)
        this.finished = true
      } finally {
        this.loading = false
      }
    },
    onRefresh () {
      this.finished = false
      this.loading = true
      this.page = 1
      this.onLoad()
    },
    onDateConfirm (time) {
      this.planForm.planTime = moment(time).format('YYYY-MM-DD')
      this.showDatePicker = false
    },
    handlePlan (type) {
      this.currendOper = type
      this.planPopup = true
    },
    handleOper (type, params) {
      if (type === 'add') {
        if (this.paramUrl.targetId) {
          if (this.checkPer(['admin', 'app:expandCustomer']) && this.checkPer(['admin', 'app:customer']) && this.checkPer(['admin', 'app:sd'])) {
            this.$refs.planTypeRef.planTypePopup = true
          } else {
            if (this.checkPer(['admin', 'app:expandCustomer']) || this.checkPer(['admin', 'app:customer'])) {
              this.$router.push(`/shared/selectVisitPlan?pageType=store&planId=${this.currentPlanInfo.id}`)
            } else if (this.checkPer(['admin', 'app:sd'])) {
              this.$router.push(`/shared/selectVisitPlan?pageType=distributor&planId=${this.currentPlanInfo.id}`)
            }
          }
        } else {
          this.currendOper = type
          this.planPopup = true
        }
      } else if (type === 'confirm') {
        Toast.loading({
          message: this.$t('shared.loading'),
          forbidClick: true,
          duration: 0
        })
        const data = {
          ...this.planForm,
          targetId: this.paramUrl.targetId || '',
          targetType: this.paramUrl.targetType || ''
        }
        visitPlanAddApi(data).then(res => {
          this.currentSaveData = res.data
          Toast.clear()
          this.planPopup = false
          if (this.currendOper === 'add') {
            Notify({ type: 'success', message: this.$t('shared.success'), duration: 1500 })
            if (!this.paramUrl.targetId) {
              this.successStatus = true
              this.navTitle = this.$t('shared.title.createdSuccessfully')
            } else {
              this.onRefresh()
            }
          } else {
            this.successStatus = false
            this.onRefresh()
          }
        })
      } else if (type === 'edit') {
        this.currendOper = type
        Object.keys(this.planForm).forEach(subItem => {
          this.planForm[subItem] = params[subItem]
        })
        this.planPopup = true
      } else if (type === 'del') {
        const messageTip = this.paramUrl.pageType === 'salesDistribution' ? this.$t('shared.distributor') : this.$t('shared.store')
        Dialog.confirm({
          message: this.paramUrl.pageType ? this.$t('tips.messageFiftyOne', { targetType: messageTip }) : this.$t('tips.messageFiftyThree'), // 是否删除该拜访计划？若已经创建日程将同步取消。
          confirmButtonText: this.paramUrl.pageType ? this.$t('button.confirm') : this.$t('button.delete'),
          cancelButtonText: this.paramUrl.pageType ? this.$t('button.cancel') : this.$t('button.thinkAgain'),
          confirmButtonColor: '#d9001b'
        })
          .then(() => {
            Toast.loading({
              message: this.$t('shared.loading'),
              forbidClick: true,
              duration: 0
            })
            let data = {
              planId: params.id,
              targetId: this.paramUrl.targetId,
              targetType: this.paramUrl.targetType
            }
            const resquestApi = this.paramUrl.targetId ? visitPlanDeleteDetailApi : visitPlanDeleteApi
            if (!this.paramUrl.targetId) {
              data = params.id
            }
            resquestApi(data).then(res => {
              Toast.clear()
              Notify({ type: 'success', message: this.$t('shared.success'), duration: 1500 })
              this.onRefresh()
            })
          })
          .catch(() => {})
      }
    }
  }
}
</script>

<style lang="less" scoped>
.event-page {
  display: flex;
  flex-direction: column;
  background-color: #f7f8fa;
  height: 100%;

  .list-container {
    flex: 1;
    overflow-y: auto;
  }

  .plan-card {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px;
    border-bottom: 1px solid #ebedf0;
    background-color: #fff;
    .plan-left {
      flex: 1;
      .plan-name {
        width: 288px;
        font-size: 14px;
        font-weight: bold;
        margin-bottom: 3px;
      }
      .plan-info {
        width: 288px;
        color: #307bff;
        margin-bottom: 4px;
      }
      .plan-date {
        width: 288px;
        color: #7f7f7f;
      }
    }
    .plan-right {
      display: flex;
      justify-content: space-between;
      width: 52px;
    }
  }

  .icon-img {
    width: 20px;
    height: 20px;
  }

  .oper-btn {
    width: 100%;
    .mapping-btn {
      width: 100%;
      background-color: #307bff;
      font-weight: bold;
      font-size: 16px;
    }
  }
}
.plan-popup-content {
  padding: 10px 18px 20px 18px;
  .popup-title {
    font-weight: bold;
    font-size: 16px;
    text-align: center;
    margin-bottom: 10px;
  }
  .plan-form-content {
    max-height: 436px;
    min-height: 266px;
    margin-top: 10px;
    overflow: auto;
    .form-item {
      display: flex;
      align-items: center;
      margin-bottom: 13px;
      border-bottom: 1px solid #ebedf0;
      .label {
        width: 100px;
        display: flex;
        align-items: center;
        font-size: 12px;
        color: #333;
        margin-bottom: 8px;
        // 添加必填标记样式
        &.required {
          position: relative;
          padding-left: 12px; // 为星号预留空间
          &::before {
            content: '*';
            color: #ff4444;
            position: absolute;
            left: 0;
            top: 0;
            font-size: 14px;
            line-height: 1;
          }
        }
      }
    }
    .plan-tips {
      font-size: 11px;
      color: #b5b2b2;
    }
  }
  .operate-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 20px;
    justify-content: space-between;
    /deep/.van-button {
      width: 126px;
      height: 40px;
      background-color: #dce5f6;
      border: 1px solid #dce5f6;
      border-radius: 8px;
      color: #000;
    }
    .confirm-btn {
      width: 190px;
      color: #fff;
      background-color: #307bff;
      border: 1px solid #307bff;
    }
  }
}
.success-submit-status {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 100px;
  .success-img {
    width: 80px;
    height: 80px;
  }
  .success-tip {
    width: 260px;
    text-align: center;
    margin: 16px 0 40px 0;
    font-size: 13px;
  }
  .store-detail-btn,
  .visit-sell-in-btn {
    width: 260px;
    padding: 16px 0px;
    border: 1px solid #307bff;
    color: #307bff;
    text-align: center;
    font-weight: bold;
    font-size: 17px;
    border-radius: 30px;
    margin-bottom: 16px;
  }
}
</style>
